import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BASE_URL } from '../../models/Url';
import { of } from 'rxjs';
import { Config } from 'src/app/models/Config';

@Injectable({
  providedIn: 'root'
})
export class StartupService {
  private baseUrl!: string;
  private env!: string;

  constructor(private http: HttpClient) { }

  provideBaseUrl(): string {
    if (!this.baseUrl) {
      throw new Error('No config found');
    }
    return this.baseUrl
  }

  provideEnvironment(): string {
    if (!this.env) {
      throw new Error('No Env variable found');
    }
    return this.env
  }

  getBaseUrl(): Promise<void> {
    return this.http.get<Config>(`${environment.baseHref}/config/app.config.json`)
    .toPromise()
    .then((res) => {
      console.log('App init config - ', res);
      this.baseUrl = res.apiUrl;
      this.env = res.env;
    });
  }
}
